import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiCheckCircle } from "react-icons/hi";
import { CustomButton } from "../components/atoms/CustomButton";

const StripeConnectSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/control-panel/payment-module");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="stripe-connect-success">
      <Helmet>
        <title>{t("paymentModule.stripeConnectSuccess.pageTitle")}</title>
      </Helmet>

      <div className="container mx-auto py-6">
        <div className="mx-auto max-w-lg rounded-lg border border-gray-200 bg-white p-6">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-green-100">
            <HiCheckCircle className="h-6 w-6 text-green-600" />
          </div>

          <h1 className="text-xl font-semibold text-gray-900">
            {t("paymentModule.stripeConnectSuccess.title")}
          </h1>

          <p className="mt-0.5 text-sm text-gray-500">
            {t("paymentModule.stripeConnectSuccess.description")}
          </p>

          <p className="mt-4 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">
            {t("paymentModule.stripeConnectSuccess.accountActive")}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <CustomButton
              title={t("paymentModule.stripeConnectSuccess.returnButton")}
              onClick={() => navigate("/control-panel/payment-module")}
              variant="primary"
            />
            <span className="text-xs text-gray-500 tabular-nums">
              {t("paymentModule.stripeConnectSuccess.redirecting", {
                countdown,
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectSuccess;
